import React from 'react';

import { iconType } from 'src/types';

const NetworkEnterpriseIcon: React.FC<iconType.PropsType> = ({ style, color, onClick, className, circleColor }) => {
  return (
    <span
      className={className && className}
      role="button"
      onClick={onClick && onClick}
      onKeyDown={onClick && onClick}
      tabIndex={onClick && -1}
      style={onClick ? { cursor: 'pointer', display: 'flex' } : { display: 'flex' }}
    >
      <svg style={{ ...style }} viewBox="0 0 40 40" fill={color} xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="20" fill={circleColor} />
        <path d="M17.9521 20.8025H21.7818V22.1095H17.9521V20.8025Z" fill={color} />
        <path
          d="M26.6797 22.0412H23.0732V22.6569C23.0732 22.9971 22.7863 23.2725 22.432 23.2725H17.303C16.9487 23.2725 16.6619 22.9971 16.6619 22.6569V22.0412H13.0553C12.2264 22.0412 11.4932 21.5338 11.2308 20.7787L8.92554 14.1371V27.5818C8.92554 28.6002 9.78839 29.4287 10.8489 29.4287H28.8861C29.9466 29.4287 30.8095 28.6002 30.8095 27.5818V14.1376L28.5041 20.7787C28.2418 21.5338 27.5087 22.0412 26.6797 22.0412V22.0412Z"
          fill={color}
        />
        <path
          d="M22.4354 11H17.3017C16.2403 11 15.3766 11.8245 15.3766 12.8379V13.4506H10.0209L12.4411 20.3835C12.5289 20.6341 12.7739 20.8023 13.0503 20.8023H16.66V20.1897C16.66 19.8511 16.9471 19.577 17.3017 19.577H22.4354C22.79 19.577 23.0771 19.8511 23.0771 20.1897V20.8023H26.6869C26.9633 20.8023 27.2083 20.6341 27.296 20.3835L29.7164 13.4506H24.3605V12.8379C24.3605 11.8245 23.4969 11 22.4354 11V11ZM16.66 13.4506V12.8379C16.66 12.4999 16.9476 12.2253 17.3017 12.2253H22.4354C22.7895 12.2253 23.0771 12.4999 23.0771 12.8379V13.4506H16.66Z"
          fill={color}
        />
      </svg>
    </span>
  );
};

NetworkEnterpriseIcon.defaultProps = {
  style: { width: '35px', height: '35px', marginRight: '8px' },
  color: 'var(--primary-color)',
  onClick: undefined,
  className: undefined,
};

export default NetworkEnterpriseIcon;
